module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--de@2-c45bc474f55b8a7bc99ab10730807e17.jpg";